export default __webpack_public_path__ + "static/media/bag12.9aae1142.jfif";